import styled from 'styled-components';
import { StyledPopUpBlock } from '../styled';

export const StyledPopupHeader = styled.div`
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StyledPopUpBlockNoPadding = styled(StyledPopUpBlock)`
  padding: 0 0 20px 0;
`;
export const StyledParagraph = styled.p`
  margin-top: 20px;
  font-family: 'Archivo';
  font-size: 15px;
  line-height: 26px;
  padding: 30px;
  text-align: center;
`;
